export enum GenericStatus {
    New = "release_alert",
    Active = "progress_activity",
    Closed = "unpublished_fill",
    Resolved = "task_alt",
    Removed = "cancel",
    true = "check_circle",
    false = "cancel"
}
